__turbopack_context__.v({
  "closeButton": "Banner-module-scss-module__Lz5K4a__closeButton",
  "content": "Banner-module-scss-module__Lz5K4a__content",
  "wrapper": "Banner-module-scss-module__Lz5K4a__wrapper",
});
